import EventEmitter from 'events';
import { setEntitlement } from '../utils/entitlement';
const userlogin = 'islogged';
const loginExpiryKey = 'tokenExpiry';
const Userinfo = 'userinfo';
const localStorageKey = 'loggedIn';
// Jeton de session admin (JWT) posé par utils/firestore-shim.js à la
// réponse de POST /api/auth/login ; il part dans l'en-tête
// Authorization: Bearer de chaque appel /api/db/*.
const tokenKey = 'admin_token';

class Auth extends EventEmitter {
    authToken = null
    userProfile = null
    tokenExpiry = null
        // Login : le shim a déjà posé le jeton « admin_token » et son
        // expiration (millisecondes) ; on complète les clés de session et
        // les informations affichées dans le header de l'admin.
    localLogin(authResult) {
        if (!localStorage.getItem(loginExpiryKey)) {
            localStorage.setItem(loginExpiryKey, String(Date.now() + 12 * 60 * 60 * 1000));
        }
        const user = (authResult && authResult.user) || {};
        localStorage.setItem(userlogin, 'true');
        localStorage.setItem(localStorageKey, 'true');
        localStorage.setItem(Userinfo, JSON.stringify({
            id: user.uid || null,
            displayName: user.displayName,
            email: user.email,
            photoURL: user.photoURL,
            role: user.role || 'owner',
        }));
    }

    // Profil enrichi renvoyé par GET /api/auth/me : boutiques possédées,
    // abonnement et droits d'usage (utilisé par les pages Compte et
    // Abonnement, et par le filtrage des boutiques).
    setProfile(profile) {
        if (!profile) return;
        let info = {};
        try { info = JSON.parse(localStorage.getItem(Userinfo)) || {}; } catch (e) { info = {}; }
        const user = profile.user || {};
        localStorage.setItem(Userinfo, JSON.stringify(Object.assign({}, info, {
            id: user.id || info.id || null,
            displayName: user.displayName || info.displayName || '',
            email: user.email || info.email || '',
            photoURL: user.photoURL || info.photoURL || null,
            role: user.role || info.role || 'owner',
            sites: profile.sites || [],
            subscription: profile.subscription || null,
            entitlement: profile.entitlement || null,
        })));
        // Répercute l'entitlement dans l'état réactif partagé (sidebar +
        // garde de navigation) : voir utils/entitlement.js.
        setEntitlement(profile.entitlement || null);
    }

    getProfile() {
        try { return JSON.parse(localStorage.getItem(Userinfo)) || {}; } catch (e) { return {}; }
    }
    Logout() {
        localStorage.removeItem(loginExpiryKey);
        localStorage.removeItem(userlogin);
        localStorage.removeItem(Userinfo);
        localStorage.removeItem(localStorageKey);
        localStorage.removeItem(tokenKey);
        setEntitlement(null);
    }

    // Session valide : jeton présent et non expiré (l'expiration est
    // rafraîchie à chaque connexion, TTL de 12 h côté API).
    isAuthenticated() {
        return this.isAuthenticatedUser();
    }
    isAuthenticatedUser() {
        const expiry = Number(localStorage.getItem(loginExpiryKey));
        return (
            Boolean(localStorage.getItem(tokenKey)) &&
            Number.isFinite(expiry) &&
            Date.now() < expiry &&
            localStorage.getItem(localStorageKey) === 'true'
        );
    }

}

export default new Auth();
